import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import InfoSharpIcon from '@mui/icons-material/InfoSharp';
import { AUTHORIZED_URL_PREFIX, USER_MANAGEMENT_WITHOUTPARAM_URL, GET_EDITION_CODES_URL, REPORTS_URL, AxiosConfig } from '../../Utils/Constants';
import './reports.css';
import LykioButton from "../common/LykioButton";
import Form from 'react-bootstrap/Form';
import Loading from '../common/Loading';
import { notify, pleaseRefreshError } from '../../Utils/Notificator';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import t from '../../Utils/Translation';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ExportReactCSV from './../common/ExportReactCSV';
import friendlyDate from '../../Utils/FriendlyDate';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {Chart as ChartJS, ArcElement, Tooltip, Legend, Title,BarElement, CategoryScale, LinearScale,} from 'chart.js';
import {Bar} from 'react-chartjs-2';
import { Doughnut } from "react-chartjs-2";
import { Tooltip as MUITooltip } from '@mui/material';
import EniPlatformUsageDownload from '../eni/EniPlatformUsageDownload';
import EditionCode from './EditionCode';
import UsersEditionCodes from './UsersEditionCodes';

const Reports = () => {
	ChartJS.register(ArcElement, Tooltip, Legend, Title, ChartDataLabels,  CategoryScale, LinearScale, BarElement);
	const [isLoading, setIsLoading] = useState(false);
	const [ usageReporting, setUsageReporting ] = useState(new Map());
	const [ resultsLoaded, setResultsLoaded ] = useState(false);
	const [ groups, setGroups ] = useState([]);
	const [endDate, setEndDate] = useState(new Date());
	const [startDate, setStartDate] = useState(new Date(new Date().getFullYear(), 0, 1));
	const [csvFileName, setCsvFileName] = useState('lykio-usage-report')
	const [excelTable, setExcelTable] = useState([]);
	const [storiesCreated, setStoriesCreated] = useState([]);
	const [totalStoriesCreated, setTotalStoriesCreated] = useState(0);
	const [totalPlatformLogins, setTotalPlatformLogins] = useState(0);
	const [totatPlatformUnitViews, setTotatPlatformUnitViews] = useState(0);
	const [totatPlatformStoryViews, setTotatPlatformStoryViews] = useState(0);

	const [doughnutViewsData, setDoughnutViewsData] = useState(undefined);
	const [doughnutStoriesData, setDoughnutStoriesData] = useState(undefined);

	const [editionCodes, setEditionCodes] = useState([]);
	const [editionCodesWithAll, setEditionCodesWithAll] = useState([]);
	const [selectedEditionCode, setSelectedEditionCode] = useState('');
	const [ users, setUsers ] = useState([]);
	const [isLoadingEditionCodes, setIsLoadingEditionCodes] = useState(true);
    const [isLoadingUsers, setIsLoadingUsers] = useState(true);
	const { groupReference } = useParams();

	useEffect(()=> {
		const getEditionCodes = async() => {
			try {
				setIsLoading(true);
				const { data } = await axios.get(
					`${AUTHORIZED_URL_PREFIX}${GET_EDITION_CODES_URL}`,
					AxiosConfig()
				);
				setEditionCodes(data.editionCodes);
				const allEditionCodes = [{ name: "All" }, ...data.editionCodes];
				setEditionCodesWithAll(allEditionCodes);
				setIsLoadingEditionCodes(false);
				setIsLoading(false);
				if (!data.success) {
					notify(pleaseRefreshError);
				}
			} catch(error) {
				console.log(error);
				notify(pleaseRefreshError);
			}
		}
		const handleEditionCodeChange = () => {
			getEditionCodes();
		};
		
		window.addEventListener('editionCodeAddedOrChanged', handleEditionCodeChange);
		
		getEditionCodes();

		return () => {
			window.removeEventListener('editionCodeAddedOrChanged', handleEditionCodeChange);
		};
		
	},[]);	

	useEffect(()=>{
		const getUsers = async() => {
			try {
				setIsLoading(true);
				const { data } = await axios.post(
					`${AUTHORIZED_URL_PREFIX}${USER_MANAGEMENT_WITHOUTPARAM_URL}`,
					{ groupReference },
					AxiosConfig()
				);
				const unwantedEmails = [
					"admin@ccseducation.com","fernando.salvetti@external.identity.eni.com",
					"angela.nembrini@external.identity.eni.com","barbara.bertagni@external.identity.eni.com",
					"Angela.Nembrini@external.eni.com","Barbara.Bertagni@external.eni.com",
					"Francesco.Galina@external.eni.com","eni_testadmin@mailinator.com","eni_test1@mailinator.com",
					"test2@mailinator.com",
				];
				let filteredUsers = data.users.filter(user => !unwantedEmails.includes(user.email));
				setUsers(filteredUsers);
				setIsLoadingUsers(false);
				setIsLoading(false);
			} catch(error) {
				console.log(error);
				notify(pleaseRefreshError);
			}
		}
		const handleUserEditionCodeAdded = () => {
			getUsers();
		};
		window.addEventListener('userEditionCodeAdded', handleUserEditionCodeAdded);
		getUsers();
		return () => {
			window.removeEventListener('userEditionCodeAdded', handleUserEditionCodeAdded);
		};
	},[]);
	
	
	useEffect(()=>{
		const getReports = async() =>{
			try {
				setIsLoading(true);
				const { data } = await axios.post(
					`${AUTHORIZED_URL_PREFIX}${REPORTS_URL}`,
					{ startDate, endDate },
					AxiosConfig()
				);
				if (data.success === true) {
					setUsageReporting(data.usageReporting);
					setStoriesCreated(data.storiesCreated);
					setGroups(data.groups);
					setCsvFileName(`lykio-usage-report_${friendlyDate(startDate)}-${friendlyDate(endDate)}`)
					let excel = [];

					let loginPlatformTotals = 0;
					let storyviewsPlatformTotals = 0;
					let unitviewsPlatformTotals = 0;

					let totalDeptViewsMap = new Map();
					let totalDeptStoriesMap = new Map();

					data.usageReporting.map((usageReportingItem, i) => {
					console.log(usageReportingItem);
					let storyviews = 0;
					let unitviews = 0;

					usageReportingItem.usage.forEach((usage => {
						if(usage.unit && usage.unit!=='undefined' && usage.unit!==undefined){
							if(usage.unit.type.startsWith('Story')){
								storyviews++;
							}else{
								unitviews++;
							}
						}else{
							console.log('type not found');
						}
					}));
	
					let currentUser = usageReportingItem.usage[0].user;
					let groupName;
					if(currentUser.group && Array.isArray(currentUser.group) && currentUser.group.length>0){
						groupName = data.groups.length>0 && data.groups.filter(group => group._id===usageReportingItem.usage[0].user.group[0].toString())[0].name;
					}
					if(currentUser.group && !Array.isArray(currentUser.group)){
						groupName = data.groups.length>0 && data.groups.filter(group => group._id===usageReportingItem.usage[0].user.group)[0].name;
					}
	
					loginPlatformTotals+=usageReportingItem.logins;
					storyviewsPlatformTotals+=storyviews;
					unitviewsPlatformTotals+=unitviews;

					// 
					let dept = usageReportingItem.usage[0].user.department ? `${usageReportingItem.usage[0].user.department}` : 'Unassigned'
					if(totalDeptViewsMap.get(dept)){
						totalDeptViewsMap.set(dept,totalDeptViewsMap.get(dept)+unitviews+storyviews)
					}else{
						totalDeptViewsMap.set(dept,unitviews+storyviews)
					}

					excel.push(
						{
							lykio: i+1,
							name: `${usageReportingItem.usage[0].user.firstname} ${usageReportingItem.usage[0].user.lastname}`,
							email: usageReportingItem.user,
							logins: usageReportingItem.logins,
							totalviews: unitviews+storyviews,
							unitviews: unitviews,
							storyviews: storyviews,
							group: groupName,
							department: usageReportingItem.usage[0].user.department ? `${usageReportingItem.usage[0].user.department}` : 'Unassigned'
						}
					)})

					data.storiesCreated.forEach(entry =>{
						let dept = entry.user.department ? `${entry.user.department}` : 'Unassigned'
						if(totalDeptStoriesMap.get(dept)){
							totalDeptStoriesMap.set(dept,totalDeptStoriesMap.get(dept)+entry.stories)
						}else{
							totalDeptStoriesMap.set(dept,entry.stories)
						}
					})

					// The two maps
					console.log(totalDeptViewsMap);
					console.log(totalDeptStoriesMap);
					let deptViewsData = {
						labels: [],
						datasets: [
						{
							data: [],
							backgroundColor: ["#3e4444", "#82b74b", "#405d27","#c1946a", "#c1336f"],
							hoverBackgroundColor: ["#3e4444", "#82b74b", "#405d27","#c1946a", "#c1336f"],
							borderWidth: 2
						}
						]
					};

					let deptStoriesData = {
						labels: [],
						datasets: [
						{
							data: [],
							backgroundColor: ["#ffef96", "#50394c", "#b2b2b2","#f4e1d2", "#f2e9d2"],
							hoverBackgroundColor: ["#ffef96", "#50394c", "#b2b2b2","#f4e1d2", "#f2e9d2"],
							borderWidth: 2
						}
						]
					};


					totalDeptViewsMap.forEach((value, key) => {
						deptViewsData.labels.push(key);
						deptViewsData.datasets[0].data.push(value);
					});

					totalDeptStoriesMap.forEach((value, key) => {
						deptStoriesData.labels.push(key);
						deptStoriesData.datasets[0].data.push(value);
					});

					setDoughnutViewsData(deptViewsData);
					setDoughnutStoriesData(deptStoriesData);
					
					let calculateTotalStoriesCreated = 0;
					data.storiesCreated.forEach(entry=>{
						calculateTotalStoriesCreated+=entry.stories;
					})
					setTotalStoriesCreated(calculateTotalStoriesCreated);
					setTotalPlatformLogins(loginPlatformTotals);
					setTotatPlatformUnitViews(unitviewsPlatformTotals);
					setTotatPlatformStoryViews(storyviewsPlatformTotals);


					setExcelTable(excel);
					setResultsLoaded(true)
					setIsLoading(false);
				}else {
					notify(pleaseRefreshError);
				}
			}catch(error) {
				console.log(error);
				notify(pleaseRefreshError);
			}
		}
		getReports();
	},[]);


	const getUsagePeriodDataHandler = async() => {
		try {
			setIsLoading(true);
			const { data } = await axios.post(
				`${AUTHORIZED_URL_PREFIX}${REPORTS_URL}`,
				{ startDate, endDate },
				AxiosConfig()
			);
			if (data.success === true) {
				setUsageReporting(data.usageReporting);
				setStoriesCreated(data.storiesCreated);
				setGroups(data.groups);
				setCsvFileName(`lykio-usage-report_${friendlyDate(startDate)}-${friendlyDate(endDate)}`)
				let excel = [];
				data.usageReporting.map((usageReportingItem, i) => {
				console.log(usageReportingItem);
				let storyviews = 0;
				let unitviews = 0;
				usageReportingItem.usage.forEach((usage => {
					if(usage.unit && usage.unit!=='undefined' && usage.unit!==undefined){
						if(usage.unit.type.startsWith('Story')){
							storyviews++;
						}else{
							unitviews++;
						}
					}else{
						console.log('type not found');
					}
				}));

				let currentUser = usageReportingItem.usage[0].user;
				let groupName;
				if(currentUser.group && Array.isArray(currentUser.group) && currentUser.group.length>0){
					groupName = data.groups.length>0 && data.groups.filter(group => group._id===usageReportingItem.usage[0].user.group[0].toString())[0].name;
				}
				if(currentUser.group && !Array.isArray(currentUser.group)){
					groupName = data.groups.length>0 && data.groups.filter(group => group._id===usageReportingItem.usage[0].user.group)[0].name;
				}

				excel.push(
					{
						lykio: i+1,
						name: `${usageReportingItem.usage[0].user.firstname} ${usageReportingItem.usage[0].user.lastname}`,
						email: usageReportingItem.user,
						logins: usageReportingItem.logins,
						totalviews: unitviews+storyviews,
						unitviews: unitviews,
						storyviews: storyviews,
						group: groupName,
						department: usageReportingItem.usage[0].user.department ? `${usageReportingItem.usage[0].user.department}` : 'Unassigned'
					}
				)})
				setExcelTable(excel);
				setResultsLoaded(true)
				setIsLoading(false);
			}else {
				notify(pleaseRefreshError);
			}
		}catch(error) {
			console.log(error);
			notify(pleaseRefreshError);
		}
	}

	return (
		<div className="lykioccs-main-content">
			{(isLoading || isLoadingEditionCodes || isLoadingUsers) ? (
				<><Loading delay={true}/></>
			) : (
				<div className="lykiocss-center lykiocss-margin-top-2em">
					<Container fluid style={{ backgroundColor: 'white', margin: '1em', padding: '1em', borderRadius: '10px'}}>
					<Row style={{marginBottom:'2em'}}>
						<Col xl={5} style={{marginBottom:'1rem', maxHeight:'25rem', overflow:'auto'}}>
							<div className="lykiocss-material-table">
								<EditionCode editionCodes={editionCodes}/>
							</div>
						</Col>

						{<Col xl={7} style={{marginBottom:'1rem'}}>
							<div className="lykiocss-material-table">
								<UsersEditionCodes users={users} editionCodesList={editionCodes}/>
							</div>
						</Col>}
					</Row>

					<Row>
						<Col md={6} lg={6} style={{marginBottom:'1rem'}}>
							<Form.Select value={selectedEditionCode} onChange={(e) => setSelectedEditionCode(e.target.value)}>
								<option value="">{t('Select an edition code')}</option>
								{editionCodesWithAll.map((code) => (
									<option key={code._id} value={code.name}>
									{code.name}
									</option>
								))}
							</Form.Select>
						</Col>
						<Col md={6} lg={6} style={{marginBottom:'1rem'}}>
							<EniPlatformUsageDownload selectedEditionCode={selectedEditionCode}/>
						</Col>
					</Row>
					</Container>
				</div>
			)}
		</div>
	);
};

export default Reports;
